import React from 'react';

const SVGArrowDown: React.FC = () => {
    return (<svg width="10" height="10" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M7.44 10.44a1.5 1.5 0 0 1 2.12 0l5.94 5.939 5.94-5.94a1.5 1.5 0 0 1 2.12 2.122l-7 7a1.5 1.5 0 0 1-2.12 0l-7-7a1.5 1.5 0 0 1 0-2.122z" fill="currentColor"/></svg>);
};

export default SVGArrowDown;
